import styled from 'styled-components';

const MainContainer = styled.div`
  width: 100%;
  padding: 8px 16px;

  @media (min-width: 640px) {
    padding: 12px 16px;
  }
  @media (min-width: 768px) {
    padding: 24px 24px 12px 24px;
  }
  @media (min-width: 992px) {
    padding: 84px 24px 12px 112px;
  }
`;
const Container = styled.div`
  /* width: 100%; */
  @media (min-width: 992px) {
    width: 696px;
    margin: 0 auto;
  }
  @media (min-width: 1280px) {
    width: 744px;
  }
`;

const BackButtonContainer = styled.div`
  margin: 16px 32px;
  @media (min-width: 992px) {
    margin: 16px 32px;
  }
`;

const Title = styled.div`
  font-weight: 900;
  font-size: 18px;
  line-height: 28px;
  color: #161d1f;
  margin-bottom: 8px;
  // margin-top: 16px;
`;

const Subtitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
  &.highlight {
    color: var(--text-primary);
    margin-bottom: 32px;
  }
`;

const ContentTemp = styled.div`
  width: 100%;
  height: 200px;
`;

const Description = styled.p`
  min-width: 170px;
  text-align: left;
`;

export {
  MainContainer,
  Container,
  BackButtonContainer,
  Title,
  Subtitle,
  ContentTemp,
  Description
};
